// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DYDyE9 {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 400px;
}

.EuWEf2 {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-3, 24px);
  padding: var(--spacing-6, 48px) var(--spacing-3, 24px) var(--spacing-3, 24px);
}

.UWDijd {
  display: flex;
  align-items: center;
  justify-content: center;
}

.uKS5ua {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-xl, 20px);
  line-height: 1.4;
  color: var(--text-neutral-dark, #1f1f1f);
  text-align: center;
  margin: 0;
}

._FFque {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-3, 24px);
  border: 1px solid var(--border-neutral-light, #f2f2f2);
  border-radius: 4px;
  max-width: 574px;
  width: 100%;
}

._FZzjz {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-medium, 500);
  font-size: var(--font-size-md, 14px);
  line-height: 1.42;
  color: var(--text-neutral-dark, #1f1f1f);
  text-align: center;
  margin: 0;
}

.VwTsQp {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: var(--spacing-3, 24px);
  margin: calc(-1 * var(--spacing-3, 24px));
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/EmissorPaymentPage/components/EmissorPaymentGeneratingCharge/EmissorPaymentGeneratingCharge.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,6EAA6E;AAC/E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iEAAiE;EACjE,6CAA6C;EAC7C,oCAAoC;EACpC,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,sDAAsD;EACtD,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iEAAiE;EACjE,2CAA2C;EAC3C,oCAAoC;EACpC,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,+BAA+B;EAC/B,yCAAyC;AAC3C","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 400px;\n}\n\n.content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-3, 24px);\n  padding: var(--spacing-6, 48px) var(--spacing-3, 24px) var(--spacing-3, 24px);\n}\n\n.iconWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.title {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--font-size-xl, 20px);\n  line-height: 1.4;\n  color: var(--text-neutral-dark, #1f1f1f);\n  text-align: center;\n  margin: 0;\n}\n\n.processingBox {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: var(--spacing-3, 24px);\n  border: 1px solid var(--border-neutral-light, #f2f2f2);\n  border-radius: 4px;\n  max-width: 574px;\n  width: 100%;\n}\n\n.processingText {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-medium, 500);\n  font-size: var(--font-size-md, 14px);\n  line-height: 1.42;\n  color: var(--text-neutral-dark, #1f1f1f);\n  text-align: center;\n  margin: 0;\n}\n\n.footer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: var(--spacing-3, 24px);\n  margin: calc(-1 * var(--spacing-3, 24px));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DYDyE9`,
	"content": `EuWEf2`,
	"iconWrapper": `UWDijd`,
	"title": `uKS5ua`,
	"processingBox": `_FFque`,
	"processingText": `_FZzjz`,
	"footer": `VwTsQp`
};
module.exports = ___CSS_LOADER_EXPORT___;
